import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";
import { hideLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

export const getPaymentChartData = createAsyncThunk(
  "getPaymentChartData",
  async (url = "", thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/payments${url}`
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({
          message: "Error encountered!",
          type: "error",
        })
      );
    }
  }
);

export const chartSlice = createSlice({
  name: "chart",
  initialState: {
    paymentsData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPaymentChartData.fulfilled, (state, action) => {
      state.paymentsData = action.payload;
    });
  },
});

export const { setToken, getToken } = chartSlice.actions;

export default chartSlice.reducer;
